<template>
	<el-date-picker
	v-model="ztime"
	type="datetimerange"
	value-format="timestamp"
	range-separator="至"
	:picker-options="pickerOptions"
	v-bind="$attrs"
	ref="dateRange">
	</el-date-picker>
</template>
<script>
export default {
	data(vm) {
		return {
			pickerOptions: {
				// disabledDate(time) {
				// 	let minDate = new Date(vm.$refs.dateRange.picker.minDate).getTime() ;
				// 	let maxDate = new Date(vm.$refs.dateRange.picker.maxDate).getTime() 
				// 	let range =(1000*60*60*24*30);
				// 	if( minDate ){
				// 		return (time.getTime()>minDate+range)||(time.getTime()<minDate-range)
				// 	}
				// 	if( maxDate ) {
				// 		return (time.getTime()>maxDate+range)||(time.getTime()<maxDate-range)
				// 	}
				// 	return 
				// }
			}
		}
	},
	props: {
		startTime: String|Number,
		endTime: String|Number,
	},
	computed: {
		ztime: {
			get() {
				if(this.startTime&&this.endTime) {
					return [this.startTime, this.endTime]
				}
				return []
			},
			// minDate
			set(val) {
				let [startTime, endTime] = val;
				// if(endTime - startTime > (1000*60*60*24*30)) {
				// 	this.$message({
				// 		type: 'warning',
				// 		message: '最大时间范围不能超过一个月',
				// 	})
				// }else {
					this.$emit('update:startTime', startTime)
					this.$emit('update:endTime', endTime)
				// }
			}
		},

	},
	methods: {

	}
}
</script>